<template>
    <div class="timepiker">
        <!-- <el-date-picker
            v-model="timing"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker> -->
		<el-date-picker
		      v-model="startDa"
		      type="date"
		      placeholder="开始日期">
		</el-date-picker>&nbsp;&nbsp;至&nbsp;&nbsp;<el-date-picker
		      v-model="endDa"
		      type="date"
		      placeholder="结束日期">
		</el-date-picker>
    </div>
</template>

<script>
    export default {
        name: "timepiker",
        data() {
            return {
				startDa:'',
				endDa:''
			}
        },
        props:{
            startDate:{
                type: Number&String,
                default: null
            },
			endDate:{
			    type: Number&String,
			    default: null
			},		
        },
		mounted(){
			if(this.startDate||this.endDate){
				this.startDa=Number(this.startDate)
				this.endDa=Number(this.endDate)
			}
		},
		watch:{
		    startDa:function(val){
				this.$emit('update:startDate', val)
		    },
			endDa:function(val){
				this.$emit('update:endDate', val)
			},
			startDate:function(val){
				if(val){
					this.startDa=Number(this.startDate)
				}else{
					this.startDa=''
				}
		    },
			endDate:function(val){
				if(val){
					this.endDa=Number(this.endDate)
				}else{
					this.endDa=''
				}
			}
		}
    }
</script>

<style scoped>
    
</style>